module.exports = __webpack_public_path__ + "static/img/SouthPressCoffee.767cac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/places/SouthPressCoffee.png
// module id = eGIr
// module chunks = 0